import React from 'react'
import PropTypes from 'prop-types'
import uniq from 'lodash/uniq'
import { Flex, Box } from 'reflexbox'
import { Button, Classes, Dialog, Switch, Tag } from '@blueprintjs/core'

import UserSelect from 'src/components/UserSelect'
import TeamSelect from 'src/components/TeamSelect'
import './admin-dialog.scss'

class AdminEditingDialog extends React.Component {
    state = {
        adminUsers: this.props.runbook.admins,
        adminTeams: this.props.runbook.adminTeams,
        mode: 'adminUsers',
    }
    isUser() {
        // else it's a team
        return this.state.mode === 'adminUsers'
    }
    handleModeChange = (event) => {
        this.setState({ mode: this.isUser() ? 'adminTeams' : 'adminUsers' })
    }
    onContactSelect = (type) => (value) => {
        this.setState({ [type]: uniq([...this.state[type], value]) })
    }
    onContactClear = (type, id) => () => {
        this.setState({ [type]: this.state[type].filter((el) => el.id !== id) })
    }
    handleRunbookSave = () => {
        this.props.onConfirm(this.state.adminUsers, this.state.adminTeams)
    }
    render() {
        const { onCloseClick } = this.props

        const { adminTeams, adminUsers } = this.state
        return (
            <Dialog
                title="Edit Runbook Admins"
                className="runbook-admin-dialog"
                onClose={onCloseClick}
                isOpen={true}
            >
                <div className={Classes.DIALOG_BODY}>
                    <Flex w={1} wrap>
                        <Box w={1 / 6}>
                            <Switch
                                className="admin-mode-switch"
                                onChange={this.handleModeChange}
                            />
                        </Box>
                        <Box w={5 / 6}>
                            {this.isUser() ? (
                                <UserSelect
                                    onTeamSelect={this.onContactSelect(
                                        'adminUsers'
                                    )}
                                />
                            ) : (
                                <TeamSelect
                                    onTeamSelect={this.onContactSelect(
                                        'adminTeams'
                                    )}
                                />
                            )}
                        </Box>
                        <Box w={1}>
                            {adminUsers.map((user) => (
                                <Tag
                                    style={{ marginTop: 5, marginRight: 5 }}
                                    onRemove={this.onContactClear(
                                        'adminUsers',
                                        user.id
                                    )}
                                    key={user.id}
                                >
                                    {user.fullName} - {user.userName}
                                </Tag>
                            ))}
                        </Box>
                        <Box w={1}>
                            {adminTeams.map((team) => (
                                <Tag
                                    intent="primary"
                                    style={{ marginTop: 5, marginRight: 5 }}
                                    onRemove={this.onContactClear(
                                        'adminTeams',
                                        team.id
                                    )}
                                    key={team.id}
                                >
                                    {team.name}
                                </Tag>
                            ))}
                        </Box>
                    </Flex>
                </div>
                <div className={Classes.DIALOG_FOOTER}>
                    <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                        <Button
                            large
                            intent="primary"
                            onClick={this.handleRunbookSave}
                        >
                            Save
                        </Button>
                        <Button
                            intent="lynch-underline"
                            large
                            onClick={onCloseClick}
                        >
                            Cancel
                        </Button>
                    </div>
                </div>
            </Dialog>
        )
    }
}

AdminEditingDialog.propTypes = {
    runbook: PropTypes.object,
}

export default AdminEditingDialog
